import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "./en";
import zhLocale from "./zh";
import zhTWLocale from "./zh_tw";
import kor from "./kor";
import th from "./th";
import jp from "./jp";
Vue.use(VueI18n);
const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  },
  zh_tw: {
    ...zhTWLocale
  },
  kor: {
    ...kor
  },
  th: {
    ...th
  },
  jp: {
    ...jp
  }
};
const i18n = new VueI18n({
  locale: "en",
  messages,
  silentTranslationWarn: true
});
export default i18n;
